import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Pagination from "../../components/Pagination";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Spinner } from "react-bootstrap";
import Search from "../Search";
import Waccount from "../hotspots/waccount";

export default function WaccountsForfait({ codeforfait }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setfetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [using, setusing] = useState(false);
    const [error, setError] = useState(false);
    const [addstate, setAddstate] = useState(false);


    const [elementsList, setElementsList] = useState([]);
    const [nbpage, setNbpage] = useState(1);
    const [nbelement, setNbelement] = useState(0);
    const [page, setPage] = useState(0);

    const [isSearch, setIsSearch] = useState(false);
    const [chaine, setChaine] = useState('');

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getElementsList = async (p) => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/wifiaccounts?limit=${config.app.limit}&page=${p + 1}&codeforfait=${codeforfait}`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        setElementsList(clientarray);
                        setNbpage(data?.body?.pages);
                        setNbelement(data?.body?.length);
                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const autoSearchElement = async (c) => {
        setPage(0);
        if ((c && !isSearch) || (c && isSearch)) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);


            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/wifiaccounts?codeforfait=${codeforfait}&crit=${c}`, requestOptions).then((response) => {

                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        if (data?.head) {
                            // console.log("resonse jsondecode", data);
                            let clientarray = [];
                            clientarray = data?.body?.data;
                            setElementsList(clientarray);
                            setNbpage(data?.body?.pages);
                            setNbelement(data?.body?.length);
                            // setLoading(false);
                        } else {
                            if (data?.body?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                setError(true);
                            }
                            // setLoading(false);
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    setError(true);
                    // setLoading(false);
                }

            }).catch((err) => {
                // console.log("error", err);
                setError(true);
                // setLoading(false);
            });
        } else if (c !== "" && isSearch) {
            setIsSearch(false);
            getElementsList(page);
        } else {
            setIsSearch(false);
            getElementsList(page);
        }
    }


    // comportements
    useEffect(() => {
        getElementsList(page);
    }, []);

    useEffect(() => {
        const stimeout = setTimeout(() => {
            autoSearchElement(chaine);
        }, 1000);

        return () => clearTimeout(stimeout);
    }, [chaine]);

    const handleStart = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editforfaitlabel,
            message: textes.fr.editforfaitlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setfetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("nb", "50");
                        urlencoded.append("type", "ticket");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles/${codeforfait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Tickets générés avec succès");
                                getElementsList();
                                setfetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setfetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setfetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setfetching(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleDelete = async () => {
        confirmAlert({
            title: "Vider?",
            message: "Etes-vous sur de vouloir vider les comptes wifi expirés? cette action entraînera la suppression de ces comptes dans le routeur.",
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        // var urlencoded = new URLSearchParams();

                        // if (idrouteur) urlencoded.append("id", idrouteur);

                        var requestOptions = {
                            method: "DELETE",
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: "follow",
                        };

                        // console.log("data send", urlencoded);

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/wifiaccounts/${codeforfait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.oparationsuccess);
                                getElementsList(page);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }
                        })
                            .catch((err) => {
                                // console.log("error", err);
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleUse = async (comptewifi) => {

        confirmAlert({
            title: "Utiliser?",
            message: "Etes-vous sur de vouloir utiliser ce compte wifi? cette action entrainnera l'activiation de ce compte dans le routeur.",
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setusing(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Utilisé hors système");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/wifiaccounts/${comptewifi}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Ticket utilié avec succès");
                                getElementsList();
                                setusing(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setusing(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setusing(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setusing(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichages
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <Search
                                    chaine={chaine}
                                    setChaine={setChaine}
                                    // search={searchEmployee}
                                    placeholder="Rechercher..."
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        {(user?.isFullAction || user?.isAdminAction || user?.isGenererTicket) && <button onClick={handleStart}
                                            title="Générez de nouveaux tickets"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-ticket-alt mr-1"></i> <span>Nouveaux tickets</span>  {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isViderTicket) && <button
                                            onClick={handleDelete}
                                            title="Vider les comptes expirés"
                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                        >
                                            <i className="fa fa-trash mr-1"></i>{" "}
                                            <span>Vider comptes</span>{" "}
                                            {deleting && (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            )}
                                        </button>}
                                        <h6 className="m-0 ">
                                            {addstate
                                                ? textes.fr.wifiaccountinfoslabel
                                                : textes.fr.listwifiaccountlabel}
                                        </h6>
                                    </div>
                                    {!addstate && (
                                        <div className="card-body">
                                            <div className="table-responsive mb-3">
                                                <table className="mb-0 table table-bordered">
                                                    <thead className="bg-primary">
                                                        <tr className="bg-primary text-white">
                                                            <th className="text-center">#</th>
                                                            <th>Forfait</th>
                                                            <th>Login</th>
                                                            <th>Password</th>
                                                            <th>{textes.fr.statelabel}</th>
                                                            <th>{textes.fr.addeddatelabel}</th>
                                                            <th>{textes.fr.actionlabel}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {elementsList.length === 0 && (
                                                            <tr style={{ borderStyle: "none" }}>
                                                                <th colSpan={7} className="text-center">
                                                                    {textes.fr.nowifiaccountfound}
                                                                </th>
                                                            </tr>
                                                        )}
                                                        {elementsList.length > 0 &&
                                                            elementsList?.map((item, index) => (
                                                                <Waccount
                                                                    account={item}
                                                                    position={config.app.limit * page + index}
                                                                    key={index}
                                                                    using={using}
                                                                    onclick={() => {
                                                                        handleUse(item.code);
                                                                    }}
                                                                />))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <Pagination
                                                nbpage={nbpage}
                                                getList={getElementsList}
                                                page={page}
                                                setPage={setPage}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
